const themeUtil = {
    image,
    url,
}
export default themeUtil

const DEFAULT_THEME = 'roadie'
const THEME_FOLDER_PARAM = 'themeFolder'

type ThemeFolder = 'qa' | 'prod'
/*
  Empty string means that it is an empty value while undefined means uncached
 */
let cachedThemeFolder: ThemeFolder | '' | undefined = undefined
let cachedThemeBucket: string | undefined = undefined

function image(themeName= DEFAULT_THEME, image: string): string {
    return joinPaths(url(themeName), image)
}

function url(themeName= DEFAULT_THEME): string {
    const themeFolder = getThemeFolder()
    const themeBucket = process.env.REACT_APP_THEME_BUCKET!
    
    if (!themeFolder) {
        return joinPaths(themeBucket, themeName)
    }
    
    if (!themeBucket.endsWith('qa') && !themeBucket.endsWith('prod')) {
        return joinPaths(themeBucket, themeName)
    }
    
    if (cachedThemeBucket) {
        return joinPaths(cachedThemeBucket, themeName)
    }
    
    const lastSlash = themeBucket.lastIndexOf('/')
    const themeBucketRoot = themeBucket.substring(0, lastSlash)
    cachedThemeBucket = joinPaths(themeBucketRoot, themeFolder)
    return joinPaths(cachedThemeBucket, themeName)
}

function getThemeFolder() {
    if (!process.env.REACT_APP_CAN_USE_CUSTOM_THEME_FOLDER) {
        return cachedThemeFolder
    }
    
    if (cachedThemeFolder !== undefined) {
        return cachedThemeFolder
    }
    
    const urlParameters = new URLSearchParams(window.location.search)
    const themeFolderParameter = urlParameters.get(THEME_FOLDER_PARAM)
    
    if (!paramIsThemeFolder(themeFolderParameter)) {
        cachedThemeFolder = ''
    } else {
        cachedThemeFolder = themeFolderParameter
    }

    return cachedThemeFolder
}

function paramIsThemeFolder(param: string | null): param is ThemeFolder {
    return param === 'qa' || param === 'prod'
}

function joinPaths(...paths: string[]): string {
    return paths.join('/')
}